import * as React from 'react';
import { handleEnterOrSpaceKeyPress } from '../../Accessibility/KeyboardEvents';
import { T } from '../../Translations';
import { AnnouncementResource } from '../Decoders/Types';
import * as style from '../style.module.css';

interface Props {
  announcement: AnnouncementResource;
  onExpand: () => void;
}

const ViewAnnouncementButton: React.FC<Props> = ({ announcement, onExpand }) => {
  return (
    <button
      className={style.expandButton}
      onClick={onExpand}
      onKeyPress={handleEnterOrSpaceKeyPress(onExpand)}
      aria-label={`Expand ${announcement.payload.subject}`}
    >
      <T kind="view announcement" />
    </button>
  );
};

export default ViewAnnouncementButton;
